<template>
    <div class="container mt-5 ">
        <h3 class="py-2">{{courseDetails.course_title}}</h3>
        <b-tabs content-class="mt-3" class="course" card>
            <b-tab title="รายละเอียดหลักสูตร" active>
                <course-details :courseDetails="courseDetails"></course-details>
            </b-tab>
            <b-tab title="เข้าเรียน">
                <course-study :courseLecture="courseDetails.get_course_lectures"></course-study>
            </b-tab>
            <b-tab title="แบบทดสอบ">
                <b-container class="bv-example-row bv-example-row-flex-cols"
                             v-if="courseDetails.get_course_questions && courseDetails.get_course_questions.length">

                    <b-row align-v="center"
                           v-for="(courseQuestion, index) in courseDetails.get_course_questions"
                           :key="index"
                           :class="{ 'border-top-1': index }"
                    >

                        <b-col cols="4"
                               md="1"
                               class="text-center"
                        >
                            <icon v-show="courseQuestion.score"
                                  name="check-circle"
                                  style="width: 40px; height: 40px"></icon>
                            <icon v-show="!courseQuestion.score"
                                  name="circle"
                                  style="width: 40px; height: 40px"></icon>
                        </b-col>
                        <b-col cols="8"
                               md="6"
                        >
                            <h3>
                                บทที่ {{index+1}}
                            </h3>
                            <span class="text-reset">
                                {{ courseQuestion.question_set.set_name }}
                            </span>
                        </b-col>
                        <b-col cols="12"
                               md="4"
                        >
                            <b-row>
                                <b-col cols="12"
                                       offset-md="6"
                                       md="6"
                                       v-show="courseQuestion.score"
                                       class="text-center text-md-right"
                                >
                                    <strong>คะแนน {{ courseQuestion.score }}/{{ courseQuestion.maxScore }} </strong>
                                </b-col>
                                <b-col v-show="courseQuestion.question_set.can_retest"
                                       cols="6"
                                       class="text-center text-md-right"
                                >
                                    <b-button class="mr-2 btn-course"
                                              size="sm"
                                              @click="confirmTest(
                                      courseDetails,
                                      courseQuestion.question_set_id
                                      )">
                                        ทดสอบ
                                    </b-button>
                                </b-col>
                                <b-col v-show="courseQuestion.evaluate && courseQuestion.evaluate.length"
                                       cols="6"
                                       class="text-center text-md-right"
                                >
                                    <b-button class="btn-course"
                                              v-b-modal.course-evaluate
                                              size="sm"
                                              @click="initModelCourseProgressBar(
                                                          courseQuestion.question_set.set_name,
                                                          courseQuestion.evaluate
                                                          )">
                                        ผลการประเมิณ
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>

                </b-container>

                <b-container class="bv-example-row bv-example-row-flex-cols" v-else>
                    <b-row align-v="center">
                        <b-col>
                            <h5>หลักสูตรนี้ไม่มีบททดสอบ</h5>
                        </b-col>
                    </b-row>
                </b-container>

                <b-modal v-if="evaluateCourseQuestions && evaluateCourseQuestions.length"
                         id="course-evaluate"
                         scrollable
                         centered
                         size="lg"
                         ok-only
                         ok-title="ตกลง"
                         :title="courseProgressTitle">
                    <b-row v-for="(evaluate,index) in evaluateCourseQuestions" :key="index"
                           d-flex
                           class="mb-2"
                    >
                        <b-col cols="2" class="m-auto">
                            <h5>{{ evaluate.evaluate.code }}</h5>
                        </b-col>
                        <b-col cols="8">
                            <strong>{{ evaluate.evaluate.title }}</strong>
                            <b-progress :value="parseFloat(evaluate.value)"></b-progress>
                        </b-col>
                        <b-col cols="2" class="m-auto">
                            <h5>{{ evaluate.value }} %</h5>
                        </b-col>
                    </b-row>
                </b-modal>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Service from "../../services/index";
    import BTabs from "bootstrap-vue/src/components/tabs/tabs";
    import BTab from "bootstrap-vue/src/components/tabs/tab";
    import CourseDetails from "./CourseDetails";
    import CourseStudy from "./CourseStudy";
    import {mapGetters} from "vuex";

    export default {
        name: "Course",
        components: {BTab, BTabs, CourseDetails, CourseStudy},
        data() {
            return {
                courseCode: this.$route.params.id,
                courseDetails: {
                    get_course_lectures: []
                },
                CourseProgressTitle: null,
                evaluateCourseQuestions: []
            }
        },
        created() {
            this.getCourseLecture();
        },
        computed: {
            // mix the getters into computed with object spread operator
            ...mapGetters({
                user: "Auth/getUser"
            })
        },
        methods: {
            getCourseLecture() {
                Service.course.getByCode(this.courseCode)
                    .then((res) => {
                        this.courseDetails = res.result;
                    })
                    .catch(() => {
                        this.$toasted.show("ไม่พบคอร์สที่เลือก", {
                            type: 'error',
                            icon: 'exclamation-circle',
                            iconPack: 'fontawesome',
                            duration: 5000
                        });
                        this.$router.push({name: 'courses'})
                    })
            },
            confirmTest(course, questionSet) {
                this.$bvModal.msgBoxConfirm(`ต้องการทำแบบทดสอบของคอร์ส ${course.course_title} ?`, {
                    title: 'ยืนยันเข้าทำแบบทดสอบ',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    cancelVariant: 'danger',
                    okTitle: 'ยืนยัน',
                    cancelTitle: 'ยกเลิก',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true
                })
                    .then(value => {
                        if (value) {
                            this.goToCourseQuestion(course, questionSet)
                        }
                    })
                    .catch(err => {
                        // An error occurred
                    })
            },
            goToCourseQuestion(course, questionSet) {

                if (this.user === null) {
                    this.$toasted.show("โปรดเข้าสู่ระบบเพื่อดำเนินการต่อ", {
                        type: 'error',
                        icon: 'exclamation-circle',
                        iconPack: 'fontawesome',
                        duration: 5000
                    });
                } else {

                    Service.course.joinCourseLectureTest({
                        course_id: course.course_id,
                        question_set_id: questionSet
                    }).then(() => {
                        this.$router.push({
                            name: 'course-question',
                            params: {
                                course: course,
                                question_set_id: questionSet
                            }
                        })
                    });

                }

            },
            initModelCourseProgressBar(lectureTitle, lectureEvaluate) {
                this.courseProgressTitle = lectureTitle
                this.evaluateCourseQuestions = lectureEvaluate
            }
        }
    }
</script>

<style scoped>
    .course {
        background: #FFF none repeat scroll 0% 0%;
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
        margin-bottom: 30px;
    }

    .btn-course {
        background-color: #573C81;
        color: #FFFFFF;
        width: 125px;
    }
</style>